<template>
  <div class="w3-container w3-content" style="width: 100%; padding-top: 70px; margin: auto">    
    <!-- The Grid -->
    <div class="w3-row">
      <div class="w3-col">
        <p>
Jybe is a community of people who want to use information to bring us together, not tear us apart. We understand that it is possible to differ in opinion but still agree on basic facts. By holding ourselves and others accountable to think, research and decide what we can agree on, we can have conversations that are grounded in reality and mutual agreement rather than talking points and accusations of “fake news”.
        </p>
        <h4>How to Jybe</h4>
        <p>
There are two main components to Jybe:<br />
<br />
Statements are declarations of “fact” by community members. Statements are accompanied by “sources” to backup the claim. These sources make it easier for other members to quickly research and verify the statement. Possible reactions to a Statement are to “Jybe” (agree), “Consider”, or “Ignore”. Anyone can see which Statements you jybe (agree) with. No one but you can see which Statements you’ve ignored or are considering.<br />
<br />
Conversations are discussion threads where members can discuss their opinion on any topic. Whoever starts a Conversation decides which Statements are included as the agreement “contract”. Any other member can add Comments to a Conversation, but if they have not Jybed with all of its Statements, then all of their Comments for that Conversation will be color-coded red. Once a member has Jybed all a Conversation’s Statements, all of their Comments will be color-coded blue. Any member may also suggest Statements in a Comment that pertain to the Conversation, and the author of the Conversation then has the option to add that Statement to the Conversation.
        </p>
      </div>
    </div>
    
  <!-- End Page Container -->
  </div>
</template>

<script>
  import About from './About.ts'
  export default About
</script>